/**
 * PageHeader — banner di sezione coerente col brand Artego.
 * Sfondo gradiente verde petrolio, simbolo del brand (avatar + filigrana),
 * titolo in Manrope. Usato in cima a tutte le pagine dell'app.
 *
 * Props:
 *  - title:    titolo della sezione (es. "Anagrafica")
 *  - subtitle: descrizione breve (es. "Gestione unità, proprietari e documenti")
 *  - actions:  (opzionale) nodo con i pulsanti/azioni della pagina (a destra)
 */
export const PageHeader = ({ title, subtitle, actions }) => (
  <div className="relative overflow-hidden rounded-xl bg-gradient-to-br from-primary to-[#072628] px-5 py-6 sm:px-7 sm:py-7 shadow-sm">
    <img
      src="/assets/artego-symbol.png"
      alt=""
      aria-hidden="true"
      className="pointer-events-none select-none absolute -right-8 -bottom-12 h-44 w-44 opacity-10"
    />
    <div className="relative flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
      <div className="flex items-center gap-4">
        <img
          src="/assets/artego-symbol.png"
          alt=""
          aria-hidden="true"
          className="hidden sm:block h-12 w-12 rounded-full ring-2 ring-white/20 flex-shrink-0"
        />
        <div>
          <h1 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-white">
            {title}
          </h1>
          {subtitle ? (
            <p className="text-sm sm:text-base text-white/80 mt-1">{subtitle}</p>
          ) : null}
        </div>
      </div>
      {actions ? (
        <div className="flex flex-wrap items-center gap-2">{actions}</div>
      ) : null}
    </div>
  </div>
);

export default PageHeader;
